/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { GET_CUSTOMERS } from "./actionTypes"
import { apiError, getCustomersSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getClients } from "../../../helpers/backend_helper"

function* customers() {
  try {
    const response = yield call(getClients)
    yield put(getCustomersSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* customersListSaga() {
  yield takeEvery(GET_CUSTOMERS, customers)
}

export default customersListSaga
